import gql from 'graphql-tag';

export default gql`
  query getAllProductGroups {
    getAllProductGroups {
      data
    }
  }
`;
